import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/SEO';
import AppRoutes from './AppRoutes';
import './App.css';
const App = () => {
    return (_jsxs(HelmetProvider, { children: [_jsx(SEO, {}), _jsx(Router, { children: _jsx(AppRoutes, {}) })] }));
};
export default App;
